import { Outlet } from "react-router-dom"
import { Hero } from "~/ui/Hero"
import { Navigation } from "./elements/Navigation"
import { createContext, useContext, useState } from "react"
import { cn } from "~/common/shadcn-utils"
import { Footer } from "./elements/Footer"
import Logo from "~/images/logo-softedges.svg?react"

type LandingContextType = {
  setTitle: (title: string) => void
}
const LandingContext = createContext<LandingContextType>({
  setTitle: (title: string) => {},
})
export const useLandingContext = () => {
  return useContext(LandingContext)
}

export const LandingLayout = () => {
  const [, setTitle] = useState("")
  return (
    <LandingContext.Provider value={{ setTitle }}>
      <Navigation variant="follower" />
      <Hero variant="court" size="vignette" fixedUntilScroll>
        <Logo
          className={cn("w-[400px] h-[52px] fill-white")}
          aria-label="Racquet Magazine Logo"
        />
      </Hero>
      <Outlet />
      <Footer />
    </LandingContext.Provider>
  )
}
